import { DefaultOutlinedButton } from '@/components/buttons';
import { DefaultLoader } from '@/components/loaders';
import { SubscriptionApi } from '@/services';
import { CustomerSelectors } from '@/store/customer';
import { FormsActions } from '@/store/forms';
import { SnackbarActions } from '@/store/snackbar';
import { Box } from '@mui/material';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const key = (window.env &&
    window.env.STRIPE_PUBLIC_KEY !== '__STRIPE_PUBLIC_KEY__' &&
    window.env.STRIPE_PUBLIC_KEY) ||
    process.env.REACT_APP_STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(key);
export const StripeCheckoutForm = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [clientSecret, setClientSecret] = useState('');
    const { _id: customerId = '' } = useSelector(CustomerSelectors.makeCustomer);
    useEffect(() => {
        const getClientSecret = async () => {
            setLoading(true);
            try {
                const res = await SubscriptionApi.createStripeKickstartSession(customerId, {
                    productName: 'TestProduct1',
                });
                const data = res.data;
                setClientSecret(data.clientSecret);
            }
            catch (err) {
                const message = err.message || 'stripe checkout form error';
                dispatch(SnackbarActions.enqueueSnackbar({ message }));
            }
            finally {
                setLoading(false);
            }
        };
        if (customerId) {
            getClientSecret();
        }
    }, [customerId]);
    return (React.createElement(Box, { id: "checkout" },
        loading && React.createElement(DefaultLoader, { containerProps: { sx: { p: 6 } } }),
        !loading && (React.createElement(React.Fragment, null,
            React.createElement(DefaultOutlinedButton, { sx: { mb: 2 }, title: "Go back", onClick: () => dispatch(FormsActions.setValue({ id: 'steps', step: 2 })) }),
            clientSecret && (React.createElement(EmbeddedCheckoutProvider, { stripe: stripePromise, options: { clientSecret } },
                React.createElement(EmbeddedCheckout, null)))))));
};
